import {
  Box,
  Checkbox,
  FormHelperText,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import axios from "axios";
import { getToken, getWebsite, isObjWithValues, } from "../../../../helper";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { EDIT_SETTINGS } from "../../../../redux/actions/settingActions";
import { FormLabel } from "../../Integrations";
import { setGlobalToast } from "../../../../redux/actions/helperActions";
const CashfreeForm = () => {
  const [formData, setFormData] = useState({
    enabled: "no",
    title: "",
    description: "",
    app_id: "",
    secret_key: "",
    debug: "no",
    order_button_text: "",
    in_context: "yes",
    sandbox: "no",
  });
  const dispatch = useDispatch();
  const [visibility, setVisibility] = useState({
    app_id: false,
    secret_key: false,
  });
  const [loading, setLoading] = useState(false);
  const woocommerceCashfree_settings = useSelector(
    (state) => state.settings.woocommerceCashfree_settings
  );
  const globalToast = useSelector((state) => state.helper.globalToast);
  const theme = useTheme();
  let backgroundColor = theme.palette.primary && theme.palette.primary.main;
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  console.log(woocommerceCashfree_settings);
  useEffect(() => {
    if (isObjWithValues(woocommerceCashfree_settings))
      setFormData({ ...woocommerceCashfree_settings });
  }, [woocommerceCashfree_settings]);

  const onFormEdit = (payload) => {
    setFormData((pre) => ({ ...pre, ...payload }));
  };
  const onUpdateForm = async () => {
    let website = getWebsite();
    let token = getToken();
    if (!website && !token) return false
    setLoading(true);
    let res = await axios({
      url: `${website}/wp-json/store/v1/settings/woocommerce_cashfree_settings`,
      method: "PUT",
      headers: {
        Authorization: `Basic ${token}`,
      },
      data: {
        setting: "woocommerce_cashfree_settings",
        data: formData,
      },
    });
    console.log(res);
    if (res.data.success) {
      dispatch(
        setGlobalToast({
          ...globalToast,
          show: true,
          message: "CashFree setting saved successfully",
          severity: "success",
        })
      );
      dispatch({
        type: EDIT_SETTINGS,
        payload: {
          woocommerceCashfree_settings: res.data.data,
        },
      });
    } else {
      dispatch(
        setGlobalToast({
          ...globalToast,
          show: true,
          message: "Intregration Failed! Please try again.",
          severity: "error",
        })
      );
    }
    setLoading(false);
  };
  return (
    <Box sx={{ paddingLeft: "12px", paddingBottom: "25px" }}>
      <Stack
        direction={"row"}
        alignItems="center"
        sx={{ gap: "14px", mb: 2 }}
        justifyContent="space-between"
      >
        <Stack direction={"row"} alignItems="center" sx={{ gap: "14px" }}>
          <FormLabel variant="h6">Enable /Disabled</FormLabel>
          <Switch
            onChange={(e) => onFormEdit({ enabled: e ? "yes" : "no" })}
            checked={formData.enabled === "yes"}
            style={
              formData.enabled === "yes"
                ? {
                  border: `1px solid ${backgroundColor}`,
                  backgroundColor,
                }
                : {}
            }
          />
        </Stack>
        <LoadingButton
          loading={loading}
          variant={"contained"}
          onClick={onUpdateForm}
          sx={{ mr: 4 }}
        >
          Update
        </LoadingButton>
      </Stack>
      <Stack spacing={7} sx={{ width: isPhone ? "100%" : "70%" }}>
        <Stack>
          <FormLabel variant="h6">Title</FormLabel>
          <TextField
            value={formData.title}
            onChange={(e) => onFormEdit({ title: e.target.value })}
            size="small"
            placeholder="Title"
            helperText=""
          />
          <FormHelperText>
            This controls the title which the user sees during checkout
          </FormHelperText>
        </Stack>
        <Stack>
          <FormLabel variant="h6">Description</FormLabel>
          <TextField
            value={formData.description}
            onChange={(e) => onFormEdit({ description: e.target.value })}
            size="small"
            placeholder="Description"
            helperText=""
            multiline
            rows={3}
          />
          <FormHelperText>
            This controls the description which the user sees during checkout
          </FormHelperText>
        </Stack>
        <Stack>
          <FormLabel variant="h6">App ID</FormLabel>
          <TextField
            type={visibility.app_id ? "text" : "password"}
            value={formData.app_id}
            onChange={(e) => onFormEdit({ app_id: e.target.value })}
            size="small"
            placeholder="Key ID"
            helperText=""
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    // aria-label="toggle password visibility"
                    onClick={() =>
                      setVisibility((pre) => ({
                        ...pre,
                        app_id: !visibility.app_id,
                      }))
                    }
                    // onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {visibility.app_id ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FormHelperText>Get your App ID from Cashfree.</FormHelperText>
        </Stack>
        <Stack>
          <FormLabel variant="h6">Secret key</FormLabel>
          <TextField
            type={visibility.secret_key ? "text" : "password"}
            value={formData.secret_key}
            onChange={(e) => onFormEdit({ secret_key: e.target.value })}
            size="small"
            placeholder="Key Secret"
            // helperText=""
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    // aria-label="toggle password visibility"
                    onClick={() =>
                      setVisibility((pre) => ({
                        ...pre,
                        secret_key: !visibility.secret_key,
                      }))
                    }
                    // onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {visibility.secret_key ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FormHelperText>Get your secret Key from Cashfree.</FormHelperText>
        </Stack>
        <Stack>
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems="center"
            sx={{ gap: "14px" }}
          >
            <FormLabel variant="h6">In context</FormLabel>
            <Switch
              onChange={(e) => onFormEdit({ in_context: e ? "yes" : "no" })}
              checked={formData.in_context === "yes"}
              style={
                formData.in_context === "yes"
                  ? {
                    border: `1px solid ${backgroundColor}`,
                    backgroundColor,
                  }
                  : {}
              }
            />
          </Stack>
          <FormHelperText>
            Cashfree In Context can be used to accept payments without
            redirection
          </FormHelperText>
        </Stack>
        <Stack>
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems="center"
            sx={{ gap: "14px" }}
          >
            <FormLabel variant="h6">Sandbox</FormLabel>
            <Switch
              onChange={(e) => onFormEdit({ sandbox: e ? "yes" : "no" })}
              checked={formData.sandbox === "yes"}
              style={
                formData.sandbox === "yes"
                  ? {
                    border: `1px solid ${backgroundColor}`,
                    backgroundColor,
                  }
                  : {}
              }
            />
          </Stack>
          <FormHelperText>
            CashFree sandbox can be used to test payments.
          </FormHelperText>
        </Stack>
        <Stack>
          <Stack
            direction={"row"}
            alignItems="center"
            justifyContent={"space-between"}
            sx={{ gap: "14px" }}
          >
            <FormLabel variant="h6">Debug</FormLabel>
            <Switch
              onChange={(e) => onFormEdit({ debug: e ? "yes" : "no" })}
              checked={formData.debug === "yes"}
              style={
                formData.debug === "yes"
                  ? {
                    border: `1px solid ${backgroundColor}`,
                    backgroundColor,
                  }
                  : {}
              }
            />
          </Stack>
          <FormHelperText>
            Log CashFree events, such as HTTP requests.
          </FormHelperText>
        </Stack>
        <Stack>
          <Typography variant="h6">Order button text</Typography>
          <TextField
            value={formData.order_button_text}
            onChange={(e) => onFormEdit({ order_button_text: e.target.value })}
            size="small"
            placeholder="Order button text"
          />
          <FormHelperText>
            This controls the title which the user sees during checkout
          </FormHelperText>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CashfreeForm;
